<template>
  <div class="actions-row">
    <div class="actions">
      <template v-if="overlayOpen">
        <div @click="$emit('closeOverlay')" class="overlay__close">
          <svg viewBox="0 0 14 14" width="14" height="14" xmlns="http://www.w3.org/2000/svg" v-bind:viewbox="'0 0 14 14'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="inherit" fill-rule="evenodd"><path fill-rule="nonzero" d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"/><path fill="none" d="M-5-5h24v24H-5z"/></g></svg>
          <span>close</span>
        </div>
      </template>
      <template v-else>
        <button class="btn" @click="$emit('onShowNotes')">
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" v-bind:class="'show-notes'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="inherit"><path fill="none" d="M0 0h32v32H0z"/><path d="M19 19H7v2h12v-2zm0-8H7v2h12v-2zM7 17h19v-2H7v2zM7 7v2h19V7H7z"/></g></svg>
          Info
        </button>
        <button class="btn" @click="$emit('onSubscribe')">
          <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="inherit"><path fill="none" d="M0 0h56v56H0z"/><path d="M23.513 7.03v16.483H7.031v8.974h16.482v16.482h8.974V32.487h16.482v-8.974H32.487V7.031z"/></g></svg>
          Subscribe
        </button>
        <button class="btn" @click="$emit('onShare')">
          <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="inherit"><path fill="none" d="M0 0h56v56H0z"/><path d="M33.333 17.933V7L52 26.133 33.333 45.267V34.06C20 34.06 10.667 38.433 4 48c2.667-13.667 10.667-27.333 29.333-30.067z"/></g></svg>
          Share
        </button>
      </template>
    </div>
    <div :class="[{ overlayOpen }, 'player-branding']" title="Powered by ZenCast">
      <a
        href="https://www.zencast.fm/?utm_source=embedded%20player&utm_medium=embedded%20player&utm_campaign=embedded%20player"
        target="_blank"
      >
        <svg viewBox="0 0 679 213.43" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'logo'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M275.63 98.83h-26.95V86.06h45.74v12.77l-28.13 31.09h28.96v12.77h-47.64v-12.77l28.02-31.09zM332.85 144.45c-8.63 0-15.84-2.96-21.63-8.75-5.79-5.79-8.63-12.88-8.63-21.28s2.72-15.49 8.15-21.28c5.44-5.79 12.29-8.75 20.45-8.75s14.89 2.72 20.33 8.27c5.44 5.55 8.16 12.41 8.16 20.57 0 2.25-.12 3.78-.35 4.73h-41.96c.71 4.02 2.48 7.33 5.44 9.81 2.96 2.48 6.5 3.78 10.76 3.78 5.44 0 10.05-2.01 13.83-5.91l7.45 9.81c-2.25 2.6-5.32 4.73-9.22 6.38-3.9 1.65-8.16 2.48-12.77 2.48v.14zm-1.66-47.51c-3.55 0-6.5 1.06-8.86 3.31s-4.02 5.2-4.85 8.87h27.3c-.83-3.9-2.36-6.98-4.73-9.1-2.36-2.13-5.32-3.19-8.75-3.19l-.11.11zM386.4 142.92h-14.42V86.3h14.42v5.56c3.66-4.85 8.98-7.21 15.96-7.21 6.5 0 11.7 2.13 15.6 6.38 3.9 4.25 5.91 10.05 5.91 17.49v34.28h-14.42v-32.15c0-3.9-1.06-6.98-3.19-9.22S401.41 98 397.99 98c-3.66 0-6.5 1.06-8.51 3.31s-3.07 5.32-3.07 9.22v32.39zM480.38 103.55c-3.66-3.43-8.15-5.2-13.47-5.2-4.61 0-8.39 1.54-11.35 4.61-2.96 3.08-4.37 6.98-4.37 11.59s1.54 8.51 4.49 11.7c2.96 3.19 6.74 4.73 11.35 4.73 5.56 0 10.17-1.89 13.83-5.56l7.33 10.64c-2.25 2.48-5.32 4.49-9.22 6.03-3.9 1.54-8.04 2.36-12.41 2.36-8.39 0-15.48-2.96-21.28-8.75-5.79-5.79-8.63-12.88-8.63-21.16s2.84-15.37 8.51-21.28c5.67-5.91 12.65-8.87 20.92-8.87 9.46 0 16.9 2.84 22.34 8.51l-8.27 10.28.23.37zM537.24 136.65c-4.37 5.2-10.16 7.8-17.26 7.8-7.68 0-14.07-2.83-19.27-8.51-5.2-5.67-7.8-12.88-7.8-21.51s2.6-15.84 7.8-21.51c5.2-5.67 11.7-8.51 19.5-8.51 7.21 0 13 2.48 17.26 7.33v-5.68h14.54v56.62h-14.54l-.23-6.03zm-15.01-5.67c4.25 0 7.8-1.66 10.64-4.85 2.84-3.19 4.25-7.09 4.25-11.7s-1.42-8.51-4.25-11.7c-2.84-3.19-6.38-4.73-10.64-4.73-4.37 0-7.92 1.54-10.76 4.73-2.84 3.19-4.25 7.09-4.25 11.7s1.42 8.51 4.25 11.7c2.84 3.19 6.5 4.73 10.87 4.73l-.11.12zM580.03 101.55c0 1.77 1.06 3.19 3.19 4.25 2.13 1.07 4.73 2.01 7.68 2.84 2.95.83 5.91 1.77 8.86 2.84 2.96 1.06 5.56 2.84 7.68 5.44 2.13 2.6 3.19 5.79 3.19 9.69 0 5.08-2.01 9.34-6.15 12.77-4.14 3.43-9.93 5.08-17.38 5.08-10.4 0-18.32-3.19-23.76-9.57l8.04-9.22c4.37 4.85 9.93 7.21 16.67 7.21 2.72 0 4.85-.59 6.27-1.65 1.42-1.07 2.13-2.48 2.13-4.26 0-1.54-.71-2.84-2.25-3.9s-3.43-1.89-5.67-2.48c-2.25-.59-4.73-1.42-7.33-2.36-2.6-.95-5.08-2.01-7.33-3.19-2.25-1.18-4.14-2.95-5.67-5.32-1.54-2.36-2.25-5.08-2.25-8.27 0-4.61 1.89-8.63 5.67-11.94 3.78-3.31 9.1-4.97 15.96-4.97 10.52 0 17.97 3.07 22.46 9.34l-8.15 8.51c-3.55-4.14-8.16-6.27-13.95-6.27-2.48 0-4.37.47-5.79 1.42s-2.13 2.25-2.13 3.78v.23zM617.27 86.06h10.05V71.41h14.42v14.66h15.37v12.77h-15.25v24c0 5.32 2.13 7.92 6.5 7.92 2.72 0 4.96-.94 6.62-2.84l6.5 10.76c-3.9 3.78-9.1 5.67-15.48 5.67-5.79 0-10.4-1.77-13.71-5.44-3.31-3.66-4.96-8.87-4.96-15.6V98.83h-9.93l-.13-12.77z"/><g><path d="M157.35 193.48c-1.74 0-3.43-.88-4.4-2.47a5.146 5.146 0 011.71-7.07 84.105 84.105 0 0015.6-12.29c32.53-32.53 32.53-85.47 0-118.01-16.5-16.5-38.45-25.17-61.77-24.4-2.8.06-5.22-2.13-5.31-4.97-.09-2.84 2.13-5.22 4.97-5.31 25.82-.85 51.12 9.14 69.39 27.4 36.55 36.55 36.55 96.02 0 132.56-5.3 5.29-11.19 9.94-17.52 13.8-.83.52-1.76.76-2.67.76zM23.21 127.66c-2.59 0-4.81-1.95-5.11-4.58-3.17-28.5 6.62-56.46 26.87-76.71 10.53-10.51 22.97-18.18 37-22.78 2.7-.89 5.61.58 6.49 3.28.89 2.7-.59 5.61-3.28 6.49-12.48 4.1-23.56 10.92-32.92 20.29-18.03 18.03-26.75 42.93-23.92 68.3.31 2.82-1.72 5.37-4.54 5.68-.2.02-.4.03-.59.03zM44.59 176.14c-1.43 0-2.85-.59-3.87-1.75a93.137 93.137 0 01-16.39-26.61 5.15 5.15 0 012.85-6.7 5.15 5.15 0 016.7 2.85c3.49 8.66 8.4 16.62 14.58 23.67a5.144 5.144 0 01-.48 7.26c-.97.86-2.18 1.28-3.39 1.28zM66.92 194.52c-.87 0-1.76-.22-2.57-.69a94.052 94.052 0 01-6.38-4.05 5.14 5.14 0 01-1.3-7.16 5.14 5.14 0 017.16-1.3 83.46 83.46 0 005.67 3.6 5.147 5.147 0 011.88 7.03 5.134 5.134 0 01-4.46 2.57z"/><path d="M141.94 182.07c-1.92 0-3.76-1.08-4.65-2.93-1.22-2.56-.14-5.64 2.43-6.86 6.76-3.23 12.9-7.57 18.25-12.92 25.75-25.75 25.75-67.66 0-93.41s-67.66-25.76-93.41 0c-5.61 5.61-10.11 12.07-13.37 19.21a5.144 5.144 0 01-6.82 2.54 5.153 5.153 0 01-2.54-6.82c3.78-8.26 8.98-15.73 15.45-22.21 29.77-29.76 78.2-29.76 107.96 0 29.77 29.77 29.77 78.2 0 107.96a76.116 76.116 0 01-21.1 14.93c-.7.35-1.46.51-2.2.51zM46.51 147.44c-1.95 0-3.82-1.11-4.68-3.01-5.51-12.04-7.79-25.41-6.6-38.67.26-2.83 2.77-4.93 5.59-4.66a5.14 5.14 0 014.66 5.59c-1.03 11.47.94 23.04 5.71 33.46 1.18 2.58.05 5.64-2.54 6.82-.69.32-1.42.47-2.14.47zM82.03 182.74c-.71 0-1.42-.15-2.11-.45-8.43-3.79-16.05-9.06-22.64-15.65-.69-.69-1.36-1.38-2.01-2.09a5.14 5.14 0 01.28-7.27 5.14 5.14 0 017.27.28c.57.61 1.15 1.21 1.74 1.81 5.7 5.7 12.29 10.26 19.58 13.54 2.59 1.17 3.75 4.21 2.58 6.8a5.139 5.139 0 01-4.69 3.03z"/><path d="M159.26 138.24c-.67 0-1.35-.13-2.01-.41a5.15 5.15 0 01-2.72-6.75c7.55-17.75 3.62-38.03-10.02-51.67-16.26-16.26-42.47-18.29-60.98-4.72a5.146 5.146 0 01-6.08-8.3c22.57-16.54 54.53-14.07 74.34 5.75 16.62 16.62 21.42 41.34 12.22 62.98a5.19 5.19 0 01-4.75 3.12zM65.72 143.25c-1.8 0-3.55-.95-4.49-2.63-9.38-16.77-9.75-36.99-.98-54.1 1.3-2.53 4.4-3.53 6.93-2.23 2.53 1.3 3.53 4.4 2.23 6.93a46.919 46.919 0 00.8 44.38c1.39 2.48.5 5.61-1.98 7-.79.44-1.66.65-2.51.65z"/></g></svg>
      </a>
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/lib/helpers";

export default {
  props: {
    episode: { type: Object, required: true },
    overlayOpen: { type: Boolean, required: true }
  },

  data() {
    return {
      isMobile
    };
  }
};
</script>


<style lang="scss" scoped>
.actions-row {
  display: flex;
  justify-content: space-between;
  transition: opacity 0.2s ease;
}

.actions {
  display: flex;

  .btn {
    opacity: 0;
    color: var(--text-color);

    &:hover {
      opacity: 1;
    }

    svg {
      height: 17px;
      width: 17px;

      g {
        fill: var(--text-color);
      }
    }

    svg.show-notes {
      position: relative;
      top: 2px;
      transform: scale(1.4);
    }
  }
}

.overlay__close {
  padding: 6px 8px;
  background: rgba(black, 0);
  border-radius: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;

  span {
    color: var(--text-color);
    opacity: 0.8;
    position: relative;
    top: -1px;
  }

  &:hover {
    background: rgba(black, 0.2);
    cursor: pointer;

    img {
      opacity: 1;
    }
  }

  svg {
    height: 14px;
    width: 14px;
    opacity: 0.6;
    margin-right: 8px;

    g {
      fill: var(--text-color);
    }
  }
}

@media screen and (max-width: $breakpoint--s) {
  .player-branding {
    opacity: 1;
  }

  .actions {
    .btn {
      padding: 6px;

      svg {
        height: 16px;
        width: 16px;
      }
    }
  }
}
</style>
